import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullFormAndDatePicker.js";
import { css } from "styled-components/macro"; //eslint-disable-line

import Header from "components/headers/light.js";

export default () => {
  return (
      <>
          <AnimationRevealPage disabled={false}>
              <Header />
              <ContactUsForm />
              <Footer />
          </AnimationRevealPage>
      </>
  );
};
